import script from "./goRinSyo0075.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0075.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0075.vue?vue&type=style&index=0&id=f3ff5c44&lang=scss"

const __exports__ = script;

export default __exports__